import BaseEvent from './base_event';

export default class TutorialEvent extends BaseEvent {
    static canOccur(gameState) { return !gameState.eventsResults.tutorial; }

    enter(gameState) {
        if (typeof ga === "function") ga('send', 'event', 'game', 'TutorialEvent');

        gameState.eventsResults.tutorial = true;
        this.ui.showDialog({
            message: "Jenkins> Wake up, you lazy.. I mean capitan, sir. Looks like fuel converter just exploded.\n\n..What a nice morning. You took a sip of morning brew and look at the mess.\nAt least the fusion furnace is still intact. You heard those things could take anything for fuel...",
            gif: "assets/tutor1.gif",
            gifOffset: { x: 50, y: 0 },
            options: [{text: "Understood"}]
        }, this.end)
    }
}


// WEBPACK FOOTER //
// ./src/states/events/tutorial_event.js